import template from "./spray_application_record.html";
import en from "./en.json";
import es from "./es.json";
import moment from "moment";
import { spraySuccessState } from "../../../../base.routes";

class SprayApplicationRecordController {
    /* @ngInject */
    constructor($interval, $state) {
        this.$interval = $interval;
        this.$state = $state;
    }

    $onInit() {
        let ctrl = this;
        ctrl.record = ctrl.applicationRecord;
        ctrl.fields = ctrl.fields || [];
        ctrl.showSpinner = false;
        ctrl.clearErrors();
        ctrl.showEndSprayConfirmation = false;
        ctrl.resetEndSprayConfirmationState();

        if (ctrl.record.end_date) {
            ctrl.$state.go(spraySuccessState, {
                application_record_sid: ctrl.record.sid,
            });
            return;
        }

        ctrl.updateElapsedSprayTime();
        ctrl.elapsedTimeInterval = ctrl.$interval(function () {
            ctrl.updateElapsedSprayTime();
        }, 1000);
    }

    updateElapsedSprayTime() {
        let ctrl = this;
        let startDate = new Date(ctrl.record.start_date);
        if (Number.isNaN(startDate.getTime())) {
            ctrl.elapsedSprayTime = "00:00:00";
            return;
        }

        let elapsedMilliseconds = Math.max(0, Date.now() - startDate.getTime());
        let totalSeconds = Math.floor(elapsedMilliseconds / 1000);
        let hours = Math.floor(totalSeconds / 3600);
        let minutes = Math.floor((totalSeconds % 3600) / 60);
        let seconds = totalSeconds % 60;

        ctrl.elapsedSprayTime =
            String(hours).padStart(2, "0") +
            ":" +
            String(minutes).padStart(2, "0") +
            ":" +
            String(seconds).padStart(2, "0");
    }

    clearErrors() {
        let ctrl = this;
        ctrl.validationError = "";
        ctrl.errors = {};
    }

    beginEndSprayConfirmation() {
        let ctrl = this;
        if (ctrl.showSpinner) {
            return;
        }

        ctrl.showEndSprayConfirmation = true;
        ctrl.resetEndSprayConfirmationState();
    }

    getDefaultEndSprayDateTime() {
        let now = moment().seconds(0).milliseconds(0);
        return {
            date: now.format("MM/DD/YYYY"),
            time: now.format("HH:mm"),
        };
    }

    resetEndSprayConfirmationState() {
        let ctrl = this;
        let defaultEndSprayDateTime = ctrl.getDefaultEndSprayDateTime();
        ctrl.clearErrors();
        ctrl.endSprayDate = defaultEndSprayDateTime.date;
        ctrl.endSprayTime = defaultEndSprayDateTime.time;
    }

    cancelEndSprayConfirmation() {
        let ctrl = this;
        if (ctrl.showSpinner) {
            return;
        }

        ctrl.showEndSprayConfirmation = false;
        ctrl.clearErrors();
    }

    normalizeTimeValue(value) {
        if (value === null || value === undefined || value === "") {
            return null;
        }

        let parsedTime = moment(value, "HH:mm", true);
        if (parsedTime.isValid()) {
            return parsedTime.format("HH:mm");
        }

        parsedTime = moment(value);
        if (parsedTime.isValid()) {
            return parsedTime.format("HH:mm");
        }

        return null;
    }

    parseDateTime(dateValue, timeValue) {
        let parsedDate = moment(
            dateValue,
            ["MM/DD/YYYY", "YYYY-MM-DD", moment.ISO_8601],
            true,
        );
        if (!parsedDate.isValid()) {
            parsedDate = moment(dateValue);
        }
        if (!parsedDate.isValid()) {
            return null;
        }

        let normalizedTime = this.normalizeTimeValue(timeValue);
        if (!normalizedTime) {
            return null;
        }

        let timeParts = normalizedTime.split(":");
        if (timeParts.length !== 2) {
            return null;
        }

        let hours = Number(timeParts[0]);
        let minutes = Number(timeParts[1]);
        if (!Number.isFinite(hours) || !Number.isFinite(minutes)) {
            return null;
        }

        return parsedDate
            .clone()
            .hours(hours)
            .minutes(minutes)
            .seconds(0)
            .milliseconds(0);
    }

    buildEndDateMoment() {
        let ctrl = this;
        return ctrl.parseDateTime(ctrl.endSprayDate, ctrl.endSprayTime);
    }

    toMinuteIsoString(dateTime) {
        return dateTime.clone().utc().format("YYYY-MM-DDTHH:mm[Z]");
    }

    endSpray() {
        let ctrl = this;
        if (!ctrl.showEndSprayConfirmation) {
            ctrl.beginEndSprayConfirmation();
            return;
        }

        let endDateMoment = ctrl.buildEndDateMoment();
        if (!endDateMoment) {
            ctrl.validationError =
                "sprayApplicationRecord.INVALID_END_SPRAY_DATE_TIME";
            return;
        }

        let startDateMoment = moment(ctrl.record.start_date);
        if (
            startDateMoment.isValid() &&
            endDateMoment.isBefore(startDateMoment)
        ) {
            ctrl.validationError =
                "sprayApplicationRecord.END_SPRAY_BEFORE_START";
            return;
        }

        ctrl.showSpinner = true;
        ctrl.clearErrors();
        ctrl.record.end_date = ctrl.toMinuteIsoString(endDateMoment);
        ctrl.record
            .save()
            .then(function (record) {
                ctrl.$state.go(spraySuccessState, {
                    application_record_sid: record.sid,
                });
            })
            .catch(function (reason) {
                ctrl.errors = (reason && reason.data) || {};
                ctrl.showSpinner = false;
            });
    }

    $onDestroy() {
        let ctrl = this;
        if (ctrl.elapsedTimeInterval) {
            ctrl.$interval.cancel(ctrl.elapsedTimeInterval);
            ctrl.elapsedTimeInterval = null;
        }
    }
}

export default {
    name: "sprayApplicationRecord",
    template: template,
    controller: SprayApplicationRecordController,
    bindings: {
        applicationRecord: "<",
        fields: "<",
        pesticideProducts: "<",
    },
    translations: { en, es },
};
